/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconMontains: {
  name: 'montains';
  data: string;
} = {
  name: 'montains',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 90 612 612"><path d="M60.115 578.719a4.781 4.781 0 1 0-9.562 0 4.781 4.781 0 0 0 9.562 0zM36.208 593.063v2.391h38.25v-2.391c0-1.195-1.195-2.391-2.391-2.391h-2.391l-4.781-4.781-4.781 4.781-4.781-4.781-4.781 4.781-4.781-4.781-4.781 4.781h-2.391c-1.195 0-2.391 1.195-2.391 2.391z" transform="matrix(15 0 0 15 -524 -8374.433)"/></svg>`,
};
